(function () {
  // Mobile menu
  var header = document.querySelector('[data-header]');
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var open = header.classList.toggle('menu-open');
      document.querySelectorAll('.header__burger').forEach(function (b) { b.setAttribute('aria-expanded', open); });
    });
  });

  // Slideshow
  document.querySelectorAll('[data-slideshow]').forEach(function (el) {
    var slides = el.querySelectorAll('.slide');
    var dots = el.querySelectorAll('[data-dot]');
    if (slides.length < 2) return;
    var i = 0, timer;
    function go(n) {
      slides[i].classList.remove('is-active'); if (dots[i]) dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); if (dots[i]) dots[i].classList.add('is-active');
    }
    function play() {
      if (el.dataset.autoplay !== 'true') return;
      clearInterval(timer); timer = setInterval(function () { go(i + 1); }, parseInt(el.dataset.speed, 10) || 6000);
    }
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.dot, 10)); play(); }); });
    play();
  });

  // Collection sort
  var sort = document.querySelector('[data-sort]');
  if (sort) sort.addEventListener('change', function () {
    var u = new URL(window.location.href); u.searchParams.set('sort_by', sort.value); window.location = u.toString();
  });

  // Product page
  var product = document.querySelector('[data-product]');
  if (!product) return;
  var money = function (cents) { return '£' + (cents / 100).toFixed(2); };

  // thumbnails
  var main = product.querySelector('[data-main-img] img');
  product.querySelectorAll('[data-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      if (main) { main.removeAttribute('srcset'); main.src = t.dataset.thumb; }
      product.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  var variantSelect = product.querySelector('[data-variant-select]');
  var qtyInput = product.querySelector('[data-qty-input]');
  var addBtn = product.querySelector('[data-add]');
  var priceWrap = product.querySelector('[data-price-wrap] .price');
  var unit = parseInt(product.dataset.price, 10);
  var compare = parseInt(product.dataset.compare, 10) || 0;

  function renderBundles() {
    product.querySelectorAll('.bundle').forEach(function (b) {
      var input = b.querySelector('input');
      var q = parseInt(input.dataset.qty, 10), off = parseInt(input.dataset.off, 10) || 0;
      var full = unit * q, now = Math.round(full * (100 - off) / 100);
      var n = b.querySelector('[data-bundle-now]'), w = b.querySelector('[data-bundle-was]');
      if (n) n.textContent = money(now); if (w) w.textContent = money(full);
    });
  }

  product.querySelectorAll('.bundle input').forEach(function (input) {
    input.addEventListener('change', function () {
      product.querySelectorAll('.bundle').forEach(function (b) { b.classList.remove('is-selected'); });
      input.closest('.bundle').classList.add('is-selected');
      if (qtyInput) qtyInput.value = input.dataset.qty;
    });
  });

  var optionSelects = product.querySelectorAll('[data-option-index]');
  optionSelects.forEach(function (sel) {
    sel.addEventListener('change', function () {
      var chosen = Array.prototype.map.call(optionSelects, function (s) { return s.value; }).join('||');
      var match = Array.prototype.find.call(variantSelect.options, function (o) { return o.dataset.options === chosen; });
      if (!match) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return; }
      variantSelect.value = match.value;
      unit = parseInt(match.dataset.price, 10); compare = parseInt(match.dataset.compare, 10) || 0;
      var available = match.dataset.available === 'true';
      addBtn.disabled = !available; addBtn.textContent = available ? 'Add to basket' : 'Sold out';
      if (priceWrap) {
        priceWrap.classList.toggle('price--sale', compare > unit);
        priceWrap.innerHTML = '<span class="price__now">' + money(unit) + '</span>' +
          (compare > unit ? '<s class="price__was">' + money(compare) + '</s><span class="badge badge--sale">Save ' + Math.floor((compare - unit) * 100 / compare) + '%</span>' : '');
      }
      renderBundles();
      var u = new URL(window.location.href); u.searchParams.set('variant', match.value); history.replaceState({}, '', u.toString());
    });
  });
})();
